import { Gray, White } from '../../../constants';
import type { MotifComponent, MotifComponentProps } from '../../../motif';

export const chartSkeletonGrayVars: MotifComponentProps<MotifComponent.CHART_SKELETON> = {
  '--chart-skeleton-bg-color': Gray.V50,
  '--chart-skeleton-mask-color': Gray.V150,
  '--chart-skeleton-dark-animation-color': Gray.V150,
  '--chart-skeleton-light-animation-color': White,
};
